export const CONTACT_CHANNELS = ['phone', 'email', 'personal'] as const;
